import React, { memo } from 'react';
import proptypes from 'prop-types';
import { LandingPageRedirector, LandingPageSearchRedirector } from '@thd-nucleus/app-render';

const { string } = proptypes;

export const Redirector = memo(({ customerType, layoutType, pageId }) => {
  if (layoutType === 'Category') {
    return <LandingPageSearchRedirector navParam={pageId} />;
  }
  return <LandingPageRedirector customerType={customerType} slug={pageId} />;
});

Redirector.propTypes = {
  customerType: string,
  layoutType: string,
  pageId: string
};

Redirector.defaultProps = {
  customerType: '',
  layoutType: 'Content',
  pageId: ''
};
